/* eslint-disable lingui/text-restrictions */

import { t } from "@lingui/macro";

import { axios } from "@/client/libs/axios";
import { pollAIResult } from "../ai/poll";

type Mood = "casual" | "professional" | "confident" | "friendly";

export const changeTone = async (text: string, mood: Mood) => {
  const result = await axios.post<{ key: string }>("/ai/change-tone", {
    data: text,
    mood,
  });

  const tonedText = await pollAIResult<string>(result.data.key);
  if (!tonedText) {
    throw new Error(t`The server did not return toned text for your input.`);
  }

  return tonedText;
};
